import {BioentityAliasInfo} from 'constants/RegistryConstants';
import * as BioentityActions from 'inventory/BioentityActions';
import InventoryFileStore from 'inventory/InventoryFileStore';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {ModelManager} from 'models/managers/ModelManager';

export default class BioentityAliasInfosModelManager extends ModelManager<ManagedModelType.BIOENTITY_ALIAS_INFOS_BY_BIOENTITY_ID> {
  constructor() {
    super(ManagedModelType.BIOENTITY_ALIAS_INFOS_BY_BIOENTITY_ID);
  }

  async doFetchMulti(keys: Array<string>): Promise<void> {
    await BioentityActions.loadBioentityAliasInfos(keys);
  }

  getModel(modelKey: string): Array<BioentityAliasInfo> | null {
    return InventoryFileStore.getBioentityAliasInfos(modelKey) || null;
  }
}
